import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { GalleryLayout8 } from '@components/gallery/components/gallery-layout-8/model';
import { ContextService } from '@services/context';
import { MiddleOfficeService } from '@services/middle-office';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { MiddleOfficeButtonComponent } from '@shared/components/middle-office-button';
import { IconsDirective } from '@shared/directives';
import { SafeUrlPipe } from '@shared/pipes';

@Component({
  selector: 'app-gallery-layout-8',
  imports: [AsyncPipe, ButtonComponent, IconsDirective, MiddleOfficeButtonComponent, SafeUrlPipe, ImageComponent],
  templateUrl: './gallery-layout-8.component.html',
  styleUrl: './gallery-layout-8.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout8Component {
  readonly data = input.required<GalleryLayout8>();
  readonly context$ = inject(ContextService).getContext$();
  readonly isMiddleOfficeToken$ = inject(MiddleOfficeService).isMiddleOfficeToken$();
  showModal = signal(false);
}
